// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l8-3";
export var downloadButton = "_l8-4";
export var fileContainer = "_l8-9 _l8-7";
export var fileContainerBase = "_l8-7";
export var fileContainerFixedHeight = "_l8-8 _l8-7";
export var fileInfo = "_l8-5";
export var fileInfoWidthRestricted = "_l8-6";
export var fileType = "_l8-1";
export var fileTypeName = "_l8-2";
export var image = "_l8-0";
export var link = "_l8-b";
export var overflowEllipsis = "_l8-a";